import Modals from '@archetype-themes/modules/modal'

/*============================================================================
Back In Stock Modal Events
==============================================================================*/

const backInStockButton = document.querySelector('[data-modal-trigger]');

const modal = new Modals('BackInStockModal', 'back-in-stock-modal', {
    closeOffContentClick: true,
    solid: true
  })
  
if (backInStockButton) 
  backInStockButton.addEventListener('click', evt => {
    evt.preventDefault();
      modal.open(evt)
  });


/*============================================================================
Back In Stock Form
==============================================================================*/

if (backInStockButton) {
  const selectors = {
      form: '[data-back-in-stock-form]',
      modalTriggerContainer: '[data-modal-trigger-container]',
      emailInput: '[data-back-in-stock-email]',
      errorMessage: '[data-back-in-stock-error]',
      productInput: '[data-back-in-stock-product]',
      submitButton: '[data-back-in-stock-submit]',
      successView: '[data-back-in-stock-success-view]',
      successMessage: '[data-back-in-stock-success]',
      variantInput: '[data-back-in-stock-variant]',
      newsletterSelection: '[data-newsletter-signup]',
  };

  const form = document.querySelector(selectors.form);
  const modalTriggerContainer = document.querySelector(selectors.modalTriggerContainer);
  const emailInput = document.querySelector(selectors.emailInput);
  const errorMessageContainer = document.querySelector(selectors.errorMessage);
  const productInput = document.querySelector(selectors.productInput);
  const submitButton = document.querySelector(selectors.submitButton);
  const successMessageContainer = document.querySelector(selectors.successMessage);
  const successView = document.querySelector(selectors.successView);
  const variantInput = document.querySelector(selectors.variantInput);
  const newsletterSelection = document.querySelector(selectors.newsletterSelection);

  document.addEventListener('variant:changed', event => {
      const variant = event.detail.variant;

      variantInput.value = variant.id;

      variant.available ? modalTriggerContainer.classList.remove('active') : modalTriggerContainer.classList.add('active');
  });

  function onSubmit(event) {
      event.preventDefault();
      if (!emailInput.value || emailInput.value.length === 0) {
          errorMessageContainer.textContent = 'Please enter an email address';
          return;
      }

      if (variantInput.value && productInput.value) {
          submitButton.disabled = true;
          errorMessageContainer.textContent = '';

          const formUrlEncoded = function (x) {
              return Object.keys(x).reduce(function (p, c) {
                  return p + '&' + c + '=' + encodeURIComponent(x[c]);
              }, '');
          };

          fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
              method: 'POST',
              mode:"no-cors",
              headers: { 
                'Content-Type': 'application/x-www-form-urlencoded',
                "Access-Control-Allow-Origin": "*"
                },
              body: formUrlEncoded({
                  a: form.dataset.klaviyoKey,
                  email: emailInput.value,
                  variant: variantInput.value,
                  product: productInput.value,
                  platform: 'shopify',
                  subscribe_for_newsletter: newsletterSelection.checked,
                  g: form.dataset.listId,
              }),
          })
              .then(function () {
                submitButton.disabled = false;
                successMessageContainer.textContent = "Thank you, you will be notified when this item is back in stock.";
                successView.classList.toggle('hide');
              })
              .catch(function () {
                submitButton.disabled = false;
                errorMessageContainer.textContent = "Something went wrong, please try again";
                errorMessageContainer.classList.toggle('back-in-stock-modal-active');
              });
      }
  }

  form.addEventListener('submit', function (event) {
      onSubmit(event);
  });
}

